(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
class VideoCarousel {
  constructor(container) {
    this.container = container;
    this.originalTiles = Array.from(container.querySelectorAll("[data-tolstoy-tile-key]"));
    this.prevButton = container.querySelector(".tolstoy-previous-button");
    this.nextButton = container.querySelector(".tolstoy-next-button");
    this.videosContainer = container.querySelector(".tolstoy-carousel-videos-container");

    if (!this.originalTiles.length) {
        console.warn("VideoCarousel: No tiles found.");
        return;
    }

    // Settings
    this.isMobile = false;
    this.tileWidth = 316;
    this.mobileTileWidthPercent = 0.85;
    this.transitionDuration = 700;
    this.totalOriginalTiles = this.originalTiles.length;
    
    // Desktop: 1 center + 2 on each side (5 total)
    // Mobile: 1 center + partial views of adjacent
    this.visibleTilesCount = 5;
    this.halfVisible = 2;
    this.clonesCount = 5;
    
    this.currentIndex = 0;
    this.isAnimating = false;
    this.allTiles = [];
    this.observer = null;
    this.velocity = 0;
    this.lastTime = 0;

    // Touch/Drag state
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.dragThreshold = 50;
    this.initialTransform = 0;

    this.debounceResize = this.debounce(this.handleResize.bind(this), 250);

    this.init();
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  updateSettings() {
    const containerWidth = this.container.offsetWidth;
    this.isMobile = window.innerWidth <= 768;

    if (this.isMobile) {
        this.tileWidth = Math.min(containerWidth * 0.8, 300); // 80% width on mobile
        this.visibleTilesCount = 3; // Center + partial adjacent
        this.halfVisible = 1;
        this.clonesCount = 3;
        this.transitionDuration = 700;
    } else {
        this.tileWidth = 316;
        this.visibleTilesCount = 5; // Center + 2 on each side
        this.halfVisible = 2;
        this.clonesCount = 5;
        this.transitionDuration = 700;
    }
    
    this.currentIndex = Math.min(this.currentIndex, this.totalOriginalTiles - 1);
    this.clonesCount = Math.min(this.clonesCount, this.totalOriginalTiles);
  }

  init() {
    this.updateSettings();
    
    // Reset styles
    this.videosContainer.style.transform = "";
    this.videosContainer.style.transition = "none";
    this.originalTiles.forEach(tile => {
        tile.style.position = "";
        tile.style.left = "";
        tile.style.opacity = "";
        tile.style.zIndex = "";
        tile.style.width = "";
        tile.style.transition = "none";
        const tileElement = tile.querySelector(".tolstoy-carousel-tile");
        tileElement?.classList.remove("tolstoy-carousel-center-tile");
        const video = tile.querySelector("video");
        video?.pause();
    });
    this.videosContainer.querySelectorAll(".clone").forEach(clone => clone.remove());
    this.allTiles = [...this.originalTiles];

    // Setup intersection observer for lazy loading
    this.setupIntersectionObserver();

    this.setupClones();
    this.setupInitialPositions();
    
    this.attachEventListeners();
    this.playInitialCenterVideo(); // Trigger initial autoplay
    window.addEventListener("resize", this.debounceResize);
    this.setupCarouselVisibilityObserver(); // <--- Add this at the end of init()

  }

  setupIntersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target.querySelector('video');
          if (video && video.readyState === 0) {
            video.load();
          }
        }
      });
    }, { threshold: 0.1 });
  }

  setupCarouselVisibilityObserver() {
  const carousel = this.container;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const centerTile = this.container.querySelector(".tolstoy-carousel-center-tile");
      const video = centerTile?.querySelector("video");

      if (!video) return;

      if (entry.isIntersecting) {
        // Resume
        if (video.dataset.pausedTime) {
          console.log("[PAGE VISIBILITY] Resuming video from", video.dataset.pausedTime);
          video.currentTime = parseFloat(video.dataset.pausedTime);
          delete video.dataset.pausedTime;
        }
        if (video.paused) {
          const wasMuted = video.dataset.wasMuted === "true";
          video.muted = wasMuted;
          video.play().then(() => {
                  // Update mute icon
          const muteButton = centerTile?.querySelector(".tolstoy-carousel-mute-button");
          if (muteButton) {
          const unmuteIcon = muteButton.querySelector("svg[aria-label=\"Unmute tolstoy video\"]");
          const muteIcon = muteButton.querySelector("svg[aria-label=\"Mute tolstoy video\"]");
          if (unmuteIcon && muteIcon) {
          unmuteIcon.style.display = video.muted ? "none" : "block";
          muteIcon.style.display = video.muted ? "block" : "none";
    }
  }
}).catch(e => console.log("[PAGE VISIBILITY] Autoplay prevented", e));

        }
      } else {
        // Pause
        if (!video.paused) {
          video.dataset.pausedTime = video.currentTime;
          video.dataset.wasMuted = video.muted ? "true" : "false";
          video.pause();
          console.log("[PAGE VISIBILITY] Pausing video at", video.currentTime);
        }
      }
    });
  }, { threshold: 0.25 });

  observer.observe(carousel);
}


  handleResize() {
    const oldTileWidth = this.tileWidth;
    this.updateSettings();
    
    if (oldTileWidth !== this.tileWidth) {
      this.setupInitialPositions();
    }
  }

setupClones() {
  // Remove existing clones
  this.videosContainer.querySelectorAll(".clone").forEach(clone => clone.remove());

  if (this.totalOriginalTiles <= 1 || this.clonesCount === 0) {
    this.allTiles = [...this.originalTiles];
    this.totalAllTiles = this.allTiles.length;
    return;
  }

  const clonesStart = [];
  const clonesEnd = [];

  // ⬅️ Clones BEFORE the first visible tile (from END of original list)
  for (let i = 0; i < this.clonesCount; i++) {
    const index = (this.totalOriginalTiles - this.clonesCount + i) % this.totalOriginalTiles;
    const clone = this.originalTiles[index].cloneNode(true);
    clone.classList.add("clone", "clone-start");
    clone.setAttribute("data-clone-index", index);
    this.videosContainer.insertBefore(clone, this.videosContainer.firstChild);
    clonesStart.push(clone);
  }

  // ➡️ Clones AFTER the last visible tile (from START of original list)
  for (let i = 0; i < this.clonesCount; i++) {
    const index = i % this.totalOriginalTiles;
    const clone = this.originalTiles[index].cloneNode(true);
    clone.classList.add("clone", "clone-end");
    clone.setAttribute("data-clone-index", index);
    this.videosContainer.appendChild(clone);
    clonesEnd.push(clone);
  }

  this.allTiles = [...clonesStart, ...this.originalTiles, ...clonesEnd];
  this.totalAllTiles = this.allTiles.length;

  // Optional: observe all tiles if you're using IntersectionObserver
  this.allTiles.forEach(tile => {
  // Observe if needed
  this.observer?.observe(tile);

  // Add click listener to navigate to that tile
  const indexAttr = tile.getAttribute("data-tolstoy-tile-key") || tile.getAttribute("data-clone-index");
  const index = parseInt(indexAttr);

  tile.addEventListener("click", () => {
    this.navigateToIndex(index);
  });
});
}


  setupInitialPositions() {
    const containerWidth = this.videosContainer.offsetWidth;
    const centerOffset = containerWidth / 2 - this.tileWidth / 2;
    const initialOffset = -((this.clonesCount + this.currentIndex) * this.tileWidth) + centerOffset;

    this.videosContainer.style.transition = "none";
    this.videosContainer.style.transform = `translateX(${initialOffset}px)`;

    this.allTiles.forEach((tile, index) => {
      tile.style.position = "absolute";
      tile.style.left = `${index * this.tileWidth}px`;
      tile.style.width = `${this.tileWidth}px`;
      tile.style.transition = "none"; 
      this.updateTileStyle(tile, index * this.tileWidth + initialOffset);
    });

    void this.videosContainer.offsetWidth;

    this.videosContainer.style.transition = `transform ${this.transitionDuration}ms ease`;
    this.allTiles.forEach(tile => {
        tile.style.transition = `opacity ${this.transitionDuration}ms ease, transform ${this.transitionDuration}ms ease`;
    });
  }

  attachEventListeners() {
    // Remove previous listeners
    if (this.prevButton && this.prevButton.clickHandler) this.prevButton.removeEventListener("click", this.prevButton.clickHandler);
    if (this.nextButton && this.nextButton.clickHandler) this.nextButton.removeEventListener("click", this.nextButton.clickHandler);
    this.allTiles.forEach(tile => {
        const videoContainer = tile.querySelector(".tolstoy-carousel-video-container");
        const muteButton = tile.querySelector(".tolstoy-carousel-mute-button");
        if (videoContainer && videoContainer.clickHandler) videoContainer.removeEventListener("click", videoContainer.clickHandler);
        if (muteButton && muteButton.clickHandler) muteButton.removeEventListener("click", muteButton.clickHandler);
    });
    if (this.videosContainer.transitionEndHandler) this.videosContainer.removeEventListener("transitionend", this.videosContainer.transitionEndHandler);
    if (this.videosContainer.touchStartHandler) this.videosContainer.removeEventListener("touchstart", this.videosContainer.touchStartHandler);
    if (this.videosContainer.touchMoveHandler) this.videosContainer.removeEventListener("touchmove", this.videosContainer.touchMoveHandler);
    if (this.videosContainer.touchEndHandler) this.videosContainer.removeEventListener("touchend", this.videosContainer.touchEndHandler);
    if (this.videosContainer.touchCancelHandler) this.videosContainer.removeEventListener("touchcancel", this.videosContainer.touchCancelHandler);

    // Navigation buttons
    if (!this.isMobile) {
        if (this.prevButton) {
            this.prevButton.clickHandler = () => this.navigate(-1);
            this.prevButton.addEventListener("click", this.prevButton.clickHandler);
        }
        if (this.nextButton) {
            this.nextButton.clickHandler = () => this.navigate(1);
            this.nextButton.addEventListener("click", this.nextButton.clickHandler);
        }
    }

    // Keyboard navigation
    document.addEventListener("keydown", (e) => {
      if (e.target === document.body && !this.isAnimating) {
        if (e.key === "ArrowLeft") this.navigate(-1);
        if (e.key === "ArrowRight") this.navigate(1);
      }
    });

    // Video and mute handlers
    this.allTiles.forEach(tile => {
      const videoContainer = tile.querySelector(".tolstoy-carousel-video-container");
      const muteButton = tile.querySelector(".tolstoy-carousel-mute-button");
      const video = tile.querySelector("video");
      const originalIndex = parseInt(tile.getAttribute("data-tolstoy-tile-key") || tile.getAttribute("data-clone-index"));

      if (videoContainer) {
        videoContainer.style.cursor = "pointer";
        videoContainer.clickHandler = (e) => {
          e.stopPropagation();
          if (this.isAnimating) return;
          
          const tileCenterOffset = parseFloat(tile.style.left || 0) + this.tileWidth / 2;
          const containerCenter = this.videosContainer.offsetWidth / 2;
          const currentTransform = this.getCurrentTransform();
          const tileCenterInView = tileCenterOffset + currentTransform;
          const distanceFromCenter = Math.abs(tileCenterInView - containerCenter);

          if (distanceFromCenter < this.tileWidth / 2) {
            if (video) {
                if (video.paused) video.play().catch(e => console.log("Play failed", e));
            }
          } else {
            this.navigateToIndex(originalIndex);
          }
        };
        videoContainer.addEventListener("click", videoContainer.clickHandler);
        videoContainer.addEventListener("touchstart", this.handleTouchStart.bind(this), { passive: false });
        videoContainer.addEventListener("touchmove", this.handleTouchMove.bind(this), { passive: false });
        videoContainer.addEventListener("touchend", this.handleTouchEnd.bind(this));
        videoContainer.addEventListener("touchcancel", this.handleTouchEnd.bind(this));
      }

      if (muteButton && video) {
        const unmuteIcon = muteButton.querySelector("svg[aria-label=\"Unmute tolstoy video\"]");
        const muteIcon = muteButton.querySelector("svg[aria-label=\"Mute tolstoy video\"]");
        if (unmuteIcon && muteIcon) {
            unmuteIcon.style.display = video.muted ? "none" : "block";
            muteIcon.style.display = video.muted ? "block" : "none";
        }
        muteButton.clickHandler = (e) => this.toggleMute(e, video, muteButton);
        muteButton.addEventListener("click", muteButton.clickHandler);
      }
    });

    // Transition end handler
    this.videosContainer.transitionEndHandler = () => this.handleLoopReset();
    this.videosContainer.addEventListener("transitionend", this.videosContainer.transitionEndHandler);
    
    // Touch handlers moved to individual video containers
    // this.videosContainer.touchStartHandler = this.handleTouchStart.bind(this);
    // this.videosContainer.touchMoveHandler = this.handleTouchMove.bind(this);
    // this.videosContainer.touchEndHandler = this.handleTouchEnd.bind(this);
    // this.videosContainer.touchCancelHandler = this.handleTouchEnd.bind(this);

    // this.videosContainer.addEventListener("touchstart", this.videosContainer.touchStartHandler, { passive: false });
    // this.videosContainer.addEventListener("touchmove", this.videosContainer.touchMoveHandler, { passive: false }); 
    // this.videosContainer.addEventListener("touchend", this.videosContainer.touchEndHandler);
    // this.videosContainer.addEventListener("touchcancel", this.videosContainer.touchCancelHandler);
  }

  handleTouchStart(e) {
  if (this.isAnimating) return;
  this.isDragging = true;
  this.startX = e.touches[0].clientX;
  this.startY = e.touches[0].clientY; // NEW
  this.currentX = this.startX;
  this.initialTransform = this.getCurrentTransform();
  this.lastTime = Date.now();
  this.velocity = 0;
  this.videosContainer.style.transition = "none";
  this.videosContainer.style.touchAction = 'pan-y';
    
    const centerTile = this.container.querySelector(".tolstoy-carousel-center-tile video");
    // centerTile?.pause(); // Removed: Don't pause immediately on touch start
  }

handleTouchMove(e) {
  if (!this.isDragging || this.isAnimating) return;

  const now = Date.now();
  const deltaX = e.touches[0].clientX - this.currentX;
  const deltaY = e.touches[0].clientY - this.startY;

  // Allow vertical scroll if it's the dominant direction
  if (Math.abs(deltaY) > Math.abs(deltaX)) {
    return; // do not interfere with vertical scrolling
  }

  this.velocity = deltaX / (now - this.lastTime) || 0;
  this.lastTime = now;
  this.currentX = e.touches[0].clientX;

  if (Math.abs(deltaX) > 10) {
    e.preventDefault(); // prevent horizontal scrolling if swiping horizontally
  }

  const newTransform = this.initialTransform + (this.currentX - this.startX);
  this.videosContainer.style.transform = `translateX(${newTransform}px)`;
  this.updateAllTileStyles(newTransform);
}

  handleTouchEnd() {
    if (!this.isDragging || this.isAnimating) return;
    this.isDragging = false;
    const diffX = this.currentX - this.startX;

    this.videosContainer.style.transition = `transform ${this.transitionDuration}ms ease`;
    this.videosContainer.style.touchAction = '';

    if (Math.abs(this.velocity) > 0.5) {
      const direction = this.velocity > 0 ? -1 : 1;
      this.navigate(direction);
    } else if (Math.abs(diffX) > this.dragThreshold) {
      const tilesSwiped = Math.round(diffX / this.tileWidth);
      this.navigate(-tilesSwiped);
    } else {
      const containerWidth = this.videosContainer.offsetWidth;
      const centerOffset = containerWidth / 2 - this.tileWidth / 2;
      const targetTransform = -((this.clonesCount + this.currentIndex) * this.tileWidth) + centerOffset;
      this.videosContainer.style.transform = `translateX(${targetTransform}px)`;
      this.updateAllTileStyles(targetTransform);
      
      const centerVideo = this.container.querySelector(".tolstoy-carousel-center-tile video");
      centerVideo?.play().catch(e => console.log("Autoplay prevented:", e));
    }
    
    this.startX = 0;
    this.currentX = 0;
    this.initialTransform = 0;
  }
  
  getCurrentTransform() {
    const transformStyle = window.getComputedStyle(this.videosContainer).transform;
    if (transformStyle === "none") return 0;
    const matrix = new DOMMatrixReadOnly(transformStyle);
    return matrix.m41;
  }

navigate(direction) {
  if (this.isAnimating) return;
  this.isAnimating = true;

  const newIndex = (this.currentIndex + direction + this.totalOriginalTiles) % this.totalOriginalTiles;
  const currentAbsoluteIndex = this.clonesCount + this.currentIndex;
  let targetAbsoluteIndex = -1;
  let minDistance = Infinity;

  this.allTiles.forEach((tile, absIndex) => {
    const attr = tile.getAttribute("data-tolstoy-tile-key") || tile.getAttribute("data-clone-index");
    const tileIndex = parseInt(attr);
    if (tileIndex !== newIndex) return;

    const distance = Math.abs(absIndex - currentAbsoluteIndex);
    if (distance < minDistance) {
      minDistance = distance;
      targetAbsoluteIndex = absIndex;
    }
  });

  if (targetAbsoluteIndex === -1) return;

  const containerWidth = this.videosContainer.offsetWidth;
  const centerOffset = containerWidth / 2 - this.tileWidth / 2;
  const newTransform = -(targetAbsoluteIndex * this.tileWidth) + centerOffset;

  this.videosContainer.style.transition = `transform ${this.transitionDuration}ms ease`;
  this.videosContainer.style.transform = `translateX(${newTransform}px)`;

  this.updateAllTileStyles(newTransform);
  this.currentIndex = newIndex;
}


navigateToIndex(index) {
  if (this.isAnimating || index === this.currentIndex) return;

  const currentAbsoluteIndex = this.clonesCount + this.currentIndex;
  let targetAbsoluteIndex = -1;
  let minDistance = Infinity;

  this.allTiles.forEach((tile, absIndex) => {
    const attr = tile.getAttribute("data-tolstoy-tile-key") || tile.getAttribute("data-clone-index");
    const tileIndex = parseInt(attr);
    if (tileIndex !== index) return;

    const distance = Math.abs(absIndex - currentAbsoluteIndex);
    if (distance < minDistance) {
      minDistance = distance;
      targetAbsoluteIndex = absIndex;
    }
  });

  if (targetAbsoluteIndex === -1) return;

  const containerWidth = this.videosContainer.offsetWidth;
  const centerOffset = containerWidth / 2 - this.tileWidth / 2;
  const newTransform = -(targetAbsoluteIndex * this.tileWidth) + centerOffset;

  this.videosContainer.style.transition = `transform ${this.transitionDuration}ms ease`;
  this.videosContainer.style.transform = `translateX(${newTransform}px)`;

  this.updateAllTileStyles(newTransform);

  // Update the logical index
  this.currentIndex = index;
  this.isAnimating = true;
}



  handleLoopReset() {
    if (!this.isAnimating) return;

    const currentTransform = this.getCurrentTransform();
    const containerWidth = this.videosContainer.offsetWidth;
    const centerOffset = containerWidth / 2 - this.tileWidth / 2;
    const targetTransform = -((this.clonesCount + this.currentIndex) * this.tileWidth) + centerOffset;

    const resetThreshold = (this.totalOriginalTiles * this.tileWidth) / 2;
    if (Math.abs(currentTransform - targetTransform) >= resetThreshold) {
        this.videosContainer.style.transition = "none";
        this.videosContainer.style.transform = `translateX(${targetTransform}px)`;
        void this.videosContainer.offsetWidth;
        this.videosContainer.style.transition = `transform ${this.transitionDuration}ms ease`;
        this.updateAllTileStyles(targetTransform); 
    }
    
    this.isAnimating = false;
  }

  updateAllTileStyles(currentContainerTransform) {
    this.allTiles.forEach((tile, index) => {
        this.updateTileStyle(tile, index * this.tileWidth + currentContainerTransform);
    });
  }

  updateTileStyle(tile, tileLeftRelativeToViewport) {
    const containerWidth = this.videosContainer.offsetWidth;
    const viewportCenter = containerWidth / 2;
    const tileCenter = tileLeftRelativeToViewport + this.tileWidth / 2;
    const distanceFromCenter = Math.abs(tileCenter - viewportCenter);
    const relativePosition = Math.round((tileCenter - viewportCenter) / this.tileWidth);

    // Opacity
    const fadeStartDistance = this.tileWidth * 0.5;
    const fadeEndDistance = this.tileWidth * 2.5;
    let opacity = 1;
    if (distanceFromCenter > fadeStartDistance) {
        opacity = Math.max(0, 1 - (distanceFromCenter - fadeStartDistance) / (fadeEndDistance - fadeStartDistance));
    }
    tile.style.opacity = opacity;

    // Z-Index
    tile.style.zIndex = 10 - Math.abs(relativePosition);

    // Center Tile Logic
    const tileElement = tile.querySelector(".tolstoy-carousel-tile");
    const video = tile.querySelector("video");
if (relativePosition === 0) {
  console.log("[Center] Tile in center view");

  tileElement?.classList.add("tolstoy-carousel-center-tile");

  if (video) {
    if (video.dataset.pausedTime) {
      console.log("[Center] Resuming from paused time:", video.dataset.pausedTime);
      video.currentTime = parseFloat(video.dataset.pausedTime);
      delete video.dataset.pausedTime;
    }

    if (!this.isDragging && video.paused) {
      console.log("[Center] Attempting to play center video");
      video.muted = true; // Ensure autoplay works on mobile
      video.play().catch((e) => console.log("[Center] Autoplay prevented:", e));
    }

    // Update mute icons
    const muteButton = tile.querySelector(".tolstoy-carousel-mute-button");
    if (muteButton) {
      const unmuteIcon = muteButton.querySelector("svg[aria-label=\"Unmute tolstoy video\"]");
      const muteIcon = muteButton.querySelector("svg[aria-label=\"Mute tolstoy video\"]");
      if (unmuteIcon && muteIcon) {
        unmuteIcon.style.display = video.muted ? "none" : "block";
        muteIcon.style.display = video.muted ? "block" : "none";
      }
    }

    if (video.readyState === 0) {
      console.log("[Center] Lazy loading video");
      video.load();
    }
  }
} else {
  tileElement?.classList.remove("tolstoy-carousel-center-tile");

  if (video && !video.paused) {
    console.log("[Non-Center] Pausing video, saving time:", video.currentTime);
    video.dataset.pausedTime = video.currentTime;
    video.pause();
  }
}

  }

  toggleMute(e, video, button) {
    e.stopPropagation();
    if (!video) return;
    video.muted = !video.muted;
    const unmuteIcon = button.querySelector("svg[aria-label=\"Unmute tolstoy video\"]");
    const muteIcon = button.querySelector("svg[aria-label=\"Mute tolstoy video\"]");
    if (unmuteIcon && muteIcon) {
      unmuteIcon.style.display = video.muted ? "none" : "block";
      muteIcon.style.display = video.muted ? "block" : "none";
    }
  }

  playInitialCenterVideo() {
    // Add a slight delay to ensure the DOM is ready and styles applied
    setTimeout(() => {
        const centerIndex = this.clonesCount + this.currentIndex;
        if (centerIndex >= 0 && centerIndex < this.allTiles.length) {
            const centerTile = this.allTiles[centerIndex];
            const video = centerTile?.querySelector("video");
            
            // Check if video exists and is ready or can be played
            if (video) {
                video.muted = true; // Ensure muted
                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(error => {
                        console.log("Initial autoplay failed:", error);
                        // Autoplay was prevented, browser might require user interaction.
                    });
                }
            } else {
                 console.log("Initial center video not found or tile not ready.");
            }
        } else {
            console.log("Initial center index out of bounds.");
        }
    }, 100); // 100ms delay
  }
}

// Initialize on load and Shopify section events
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".tolstoy-carousel").forEach((container) => {
    if (!container.classList.contains("js-carousel-initialized")) {
        new VideoCarousel(container);
        container.classList.add("js-carousel-initialized");
    }
  });
});

document.addEventListener("shopify:section:load", () => {
  document.querySelectorAll(".tolstoy-carousel").forEach((container) => {
    if (!container.classList.contains("js-carousel-initialized")) {
        new VideoCarousel(container);
        container.classList.add("js-carousel-initialized");
    }
  });
});

document.addEventListener("shopify:section:unload", (e) => {
  const container = e.target.querySelector(".tolstoy-carousel");
  if (container && container.classList.contains("js-carousel-initialized")) {
    container.classList.remove("js-carousel-initialized");
    // Cleanup any observers or event listeners here if needed
  }
});


  } catch(e) { console.error(e); }
})();
})();
